import { render, staticRenderFns } from "./EditReportDefinition.vue?vue&type=template&id=58b71f6c"
import script from "./EditReportDefinition.vue?vue&type=script&lang=js"
export * from "./EditReportDefinition.vue?vue&type=script&lang=js"
import style0 from "./EditReportDefinition.vue?vue&type=style&index=0&id=58b71f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports